import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import { BrandMark } from '../BrandMark';

import { footerStyles as styles } from './Footer.styles';

/**
 * Marketing footer.
 * Figma: node 59:24055 on landing frame 58:39161.
 */
export function Footer() {
  return (
    <Box component="footer" sx={styles.root}>
      <Box sx={styles.brand}>
        <BrandMark variant="full" height={40} />
      </Box>
      <Box sx={styles.legalRow}>
        <Link href="/privacy-policy" sx={styles.legalLink}>
          Privacy Policy
        </Link>
        <Link href="/terms-and-conditions" sx={styles.legalLink}>
          Terms &amp; Conditions
        </Link>
        <Typography component="span" sx={styles.legalText}>
          © {new Date().getFullYear()} 530A Solutions
        </Typography>
      </Box>
    </Box>
  );
}
